(ns app.front.view.admin.excise.core
  {:clj-kondo/config '{:linters {:unused-namespace {:exclude [app.front.view.admin.excise.data-import]}}}}
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.util :refer [for-frag]]
            [app.front.view.admin.excise.common :as excise-common]
            [app.front.view.admin.excise.data-import] ; needed to define multifns
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::fetch-candidates
  (fn [_ _]
    {:comm/command {:command    :admin/find-excise-candidates
                    :method     :get
                    :on-success [::fetch-candidates.success]}}))

(rf/reg-event-fx ::fetch-candidates.success
  (fn [{:keys [db]} [_ status {:keys [entities] :as data}]]
    {:db       (cond-> db
                 (= status 200) (assoc ::excise-common/candidates (dissoc data :entities)))
     :dispatch [::entities/merge-entity-db status (du/entities->entity-db entities)]}))

(rf/reg-event-fx ::fetch-candidate
  (fn [_ [_ type id]]
    {:comm/command {:command    :admin/get-excise-candidate
                    :method     :post
                    :data       (util/mmap type id)
                    :on-success [::fetch-candidate.success id]}}))

(rf/reg-event-db ::fetch-candidate.success
  (fn [db [_ id status datoms]]
    (cond-> db
      (= status 200) (assoc-in [::candidate id] datoms))))

(rf/reg-event-fx ::perform-excise
  (fn [_ [_ type id]]
    {:comm/command {:command    :admin/perform-excise
                    :method     :post
                    :data       (util/mmap type id)
                    :on-success [::perform-excise.success]}}))

(rf/reg-event-fx ::perform-excise.success
  (fn [_ [_ status _]]
    (when (= status 200)
      {:route/push {:route :view/admin.excise}})))

(rf/reg-sub ::all-datoms
  :-> ::candidate)

(rf/reg-sub ::datoms
  :<- [::all-datoms]
  (fn [datoms [_ id]]
    (get datoms id)))

(rf/reg-sub ::has-selectable-candidates?
  :<- [::excise-common/selectable-candidates]
  (fn [candidates _] (boolean (seq candidates))))

(defn view []
  (let [tr            (<sub [:tr])
        selected-type (<sub [::excise-common/selected-type])]
    [excise-common/page
     [excise-common/section
      [:h2 "Candidate data"]
      [ui-cs/content-switcher
       {:items     (<sub [::excise-common/types])
        :tr        tr
        :val->str  (comp tr vector)
        :current   selected-type
        :on-change #(>evt [::excise-common/select-type])
        :class     "mb-4"}]
      (if (<sub [::has-selectable-candidates?])
        [excise-common/data-select selected-type]
        [:div "All clean, nothing to excise"])]]))

(defn type-kw [type-name]
  (keyword "excise.type" type-name))

(defn perform-view [{{{:keys [id type]} :path} :parameters}]
  (let [tr          (<sub [:tr])
        datoms      (<sub [::datoms id])
        excise-type (type-kw type)]
    [excise-common/page
     [excise-common/section
      [ui/modal-confirmation-button {:id                  "confirm-excise"
                                     :tr                  tr
                                     :trigger-button-text "Perform excise"
                                     :trigger-button-opts {:icon     i/warning
                                                           :disabled (empty? datoms)}
                                     :on-yes-click        #(>evt [::perform-excise excise-type id])}
       "Has a backup been made? Have you ensured the data to be excised looks correct?"]
      [:ul.mt-4
       (for-frag [d datoms]
         [:li.font-mono (str d)])]]]))

(def route
  {:name        :view/admin.excise
   :view        view
   :public?     false
   :controllers [{:start (fn [_]
                           (>evt [::fetch-candidates]))}]})

(def perform-route
  {:name        :view/admin.excise.perform
   :view        perform-view
   :public?     false
   :parameters  {:path {:id   s/Int
                        :type s/Str}}
   :controllers [{:parameters {:path [:id :type]}
                  :start      (fn [{{:keys [id type]} :path}]
                                (>evt [::fetch-candidate (type-kw type) id]))}]})
